export default __webpack_public_path__ + "static/media/2.efc8041c.png";